import { render, staticRenderFns } from "./text-elem.vue?vue&type=template&id=0c2452dc&scoped=true"
import script from "./text-elem.vue?vue&type=script&lang=js"
export * from "./text-elem.vue?vue&type=script&lang=js"
import style0 from "./text-elem.vue?vue&type=style&index=0&id=0c2452dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2452dc",
  null
  
)

export default component.exports